export default __webpack_public_path__ + "static/mpm-cf8c32ecad9067701929b8c69f6c2123.png";